import SoloRank from '@/components/Rank/SoloRank/SoloRank';

export default SoloRank;
export * from '@/components/Rank/SoloRank/SoloRank.styled';
